/**
 * The pager already prints „řádky a–b z c“. A toolbar summary that only repeats
 * that count is dropped. A real total (meters, Kč, a sum) stays, without the
 * row-count sentence in front of it.
 */

// `č` is not a JS word character, so Kč cannot use `\b`.
const EXTRA_TOTAL = /kč|metr|m²|m2|\bm\b|součet|suma/i;

function isPureRowCount(part: string): boolean {
  const value = part.trim();
  if (!/^zobrazeno\b/i.test(value)) return false;
  return !EXTRA_TOTAL.test(value);
}

function stripRowCountPrefix(part: string): string {
  const comma = part.indexOf(',');
  if (comma >= 0 && isPureRowCount(part.slice(0, comma))) {
    return part.slice(comma + 1).trim();
  }
  const keyword = part.search(/\b(celkem|součet|suma|délka)\b/i);
  if (keyword > 0) return part.slice(keyword).trim();
  const paren = part.match(/\(([^)]*(?:kč|metr|\bm\b|m²|bm)[^)]*)\)/i);
  if (paren?.[1]) return paren[1].trim();
  return '';
}

export function dataTableExtraSummary(text: string | undefined | null): string {
  const raw = (text ?? '').trim();
  if (!raw) return '';
  const parts = raw
    .split(/\s*(?:·|•|\|)\s*|\s+—\s+/)
    .map((part) => part.trim())
    .filter(Boolean);
  const kept: string[] = [];
  for (const part of parts) {
    if (!/^zobrazeno\b/i.test(part)) {
      kept.push(part);
      continue;
    }
    if (isPureRowCount(part)) continue;
    const extra = stripRowCountPrefix(part);
    if (extra) kept.push(extra);
  }
  return kept.join(' · ');
}
